import styled from 'styled-components'
import { Flex } from 'pcln-design-system'

const EmailContainer = styled(Flex)`
  border-bottom: solid 1px #bfbfbf;
  text-align: center;
`

EmailContainer.displayName = 'EmailContainer'

export default EmailContainer
